package org.ksdfv.thelema.test.json

import org.ksdfv.thelema.app.APP
import org.ksdfv.thelema.json.JSON
import org.ksdfv.thelema.test.Test
import org.ksdfv.thelema.utils.LOG

class JsonTest: Test {
    override val name: String
        get() = "JSON"

    override fun testMain() {
        val floatValue = 123f
        val intValue = 123
        val boolValue = false
        val stringValue = "qwerty"

        val jsonString = JSON.printObject {
            set("floatValue", floatValue)
            set("intValue", intValue)
            set("boolValue", boolValue)
            set("stringValue", stringValue)
            set("nestedObject") {
                setArray("array") {
                    add(floatValue)
                }
            }
        }

        LOG.info("SERIALIZATION:")
        LOG.info(jsonString)

        val parsed = JSON.parseObject(jsonString)


        parsed.obj("nestedObject")

        val parsedFloat = parsed.float("floatValue")
        val parsedInt = parsed.int("intValue")
        val parsedBool = parsed.bool("boolValue")
        val parsedString = parsed.string("stringValue")
        val nestedObjectArrayValue = parsed.obj("nestedObject").array("array").float(0)

        val parsingMessage = """
-----
PARSING:
floatValue = $parsedFloat - ${if (parsedFloat != floatValue) "not " else ""}correct
intValue = $parsedInt - ${if (parsedInt != intValue) "not " else ""}correct
boolValue = $parsedBool - ${if (parsedBool != boolValue) "not " else ""}correct
stringValue = $parsedString - ${if (parsedString != stringValue) "not " else ""}correct
nested object array value: $nestedObjectArrayValue - ${if (nestedObjectArrayValue != floatValue) "not " else ""}correct
"""

        LOG.info(parsingMessage)

        APP.messageBox("JSON", "SERIALIZATION:\n$jsonString\n$parsingMessage")
    }
}